import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  filter: "All",
  search: "",
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    filterChange: (state, action) => {
      state.filter = action.payload;
    },
    searchHandle: (state, action) => {
      state.search = action.payload;
    },
  },
});

export const { filterChange, searchHandle } = filterSlice.actions;
export default filterSlice.reducer;
